export function decodeJwtClaims(token: string | undefined): Record<string, unknown> | undefined {
  if (!token) return undefined;
  const parts = token.split('.');
  if (parts.length < 2) return undefined;

  try {
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '==='.slice((payload.length + 3) % 4);
    if (typeof (globalThis as any).atob !== 'function') return undefined;

    const json = (globalThis as any).atob(padded) as string;
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return undefined;
  }
}

export function decodeJwtExpMs(token: string | undefined): number | undefined {
  const exp = decodeJwtClaims(token)?.exp;
  return typeof exp === 'number' ? exp * 1000 : undefined;
}
